import { HALF_DIVISOR } from './constants'
import type { Props } from './types'

const SIZE_MAP = {
  small: 56,
  large: 76,
}
const STROKE_WIDTH_MAP = {
  small: 6,
  large: 8,
}

const calculateProgressValues = ({ currentStep, totalSteps, size = 'small' }: Props) => {
  const clampedStep = Math.min(Math.max(currentStep, 0), totalSteps)
  const percentage = (clampedStep / totalSteps) * 100
  const normalizedProgress = percentage / 100
  const label = `${currentStep}/${totalSteps}`
  const progressSize = SIZE_MAP[size]
  const STROKE_WIDTH = STROKE_WIDTH_MAP[size]
  const RADIUS = (progressSize - STROKE_WIDTH) / HALF_DIVISOR
  const FULL_CIRCLE = HALF_DIVISOR * Math.PI * RADIUS
  const arcLength = FULL_CIRCLE * 0.75

  return {
    clampedStep,
    percentage,
    normalizedProgress,
    label,
    progressSize,
    arcLength,
    RADIUS,
    STROKE_WIDTH,
    FULL_CIRCLE,
  }
}

export default calculateProgressValues
